/* Paint and Bloom — Lumiboard behaviors (vanilla, Dawn-compatible) */
window.PaintAndBloom = window.PaintAndBloom || {};

(() => {
  const NS = window.PaintAndBloom;

  function initAll() {
    initAnnouncements();
    initGalleries();
    initVariantPickers();
    initAccordions();
    initFaqs();
    initToasts();
  }

  function initAnnouncements() {
    document.querySelectorAll("[data-pab-countdown]").forEach((el) => {
      if (el.dataset.pabInit) return;
      el.dataset.pabInit = "1";
      const hoursAttr = parseInt(el.dataset.pabHours || "24", 10);
      let h = hoursAttr,
        m = 0,
        s = 0;
      const hEl = el.querySelector("[data-h]");
      const mEl = el.querySelector("[data-m]");
      const sEl = el.querySelector("[data-s]");
      if (!hEl || !mEl || !sEl) return;
      const pad = (n) => String(n).padStart(2, "0");
      const tick = () => {
        if (s > 0) s--;
        else if (m > 0) {
          m--;
          s = 59;
        } else if (h > 0) {
          h--;
          m = 59;
          s = 59;
        } else {
          h = hoursAttr;
          m = 0;
          s = 0;
        }
        hEl.textContent = `${pad(h)} HRS`;
        mEl.textContent = `${pad(m)} MIN`;
        sEl.textContent = `${pad(s)} SEC`;
      };
      setInterval(tick, 1000);
    });
  }

  function initGalleries() {
    document.querySelectorAll("[data-pab-gallery]").forEach((root) => {
      if (root.dataset.pabInit) return;
      root.dataset.pabInit = "1";
      const main = root.querySelector("[data-pab-main]");
      const counter = root.querySelector("[data-pab-counter]");
      const thumbs = Array.from(root.querySelectorAll("[data-pab-thumb]"));
      const prev = root.querySelector("[data-pab-prev]");
      const next = root.querySelector("[data-pab-next]");
      const viewport = root.querySelector("[data-pab-thumbs-viewport]");
      const track = root.querySelector("[data-pab-thumbs-track]");
      const VISIBLE = 5;
      if (!main) return;
      let active = parseInt(root.dataset.pabActive || "0", 10);
      const total = thumbs.length || parseInt(root.dataset.pabTotal || "1", 10);
      function updateThumbTrack(idx){
        if (!track || thumbs.length <= 5){ if (track) track.style.transform="translateX(0)"; return; }
        var maxStart = thumbs.length - 5;
        var pageStart = Math.floor(idx / 5) * 5;
        if (pageStart > maxStart) pageStart = maxStart;
        if (pageStart < 0) pageStart = 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 8;
        var thumbW = thumbs[0] ? thumbs[0].offsetWidth : 0;
        var offset = pageStart * (thumbW + gap);
        track.style.transform = "translateX(-"+offset+"px)";
      }
      function update(idx) {
        const count = thumbs.length || total;
        if (idx < 0) idx = 0;
        if (idx >= count) idx = count - 1;
        root.dataset.pabActive = String(active);
        const dataSrcs = root.dataset.pabSrcs
          ? JSON.parse(root.dataset.pabSrcs)
          : null;
        if (dataSrcs && dataSrcs[active]) {
          if (main.tagName === "IMG") main.src = dataSrcs[active];
          else {
            const img = main.querySelector("img");
            if (img) img.src = dataSrcs[active];
          }
        } else if (thumbs[active]) {
          const btn = thumbs[active];
          const fullSrc = btn.getAttribute("data-full-src");
          const fullSrcset = btn.getAttribute("data-full-srcset");
          const tImg = btn.querySelector("img");
          const src = fullSrc || (tImg ? tImg.src : null);
          if (src) {
            if (main.tagName === "IMG") {
              main.src = src;
              if (fullSrcset) {
                main.setAttribute("srcset", fullSrcset);
                main.setAttribute("sizes", "(max-width: 749px) 100vw, 600px");
              } else if (tImg && tImg.getAttribute("srcset")) {
                main.setAttribute("srcset", tImg.getAttribute("srcset"));
                main.setAttribute("sizes", "(max-width: 749px) 100vw, 600px");
              }
            } else {
              const img = main.querySelector("img");
              if (img) {
                img.src = src;
                if (fullSrcset) {
                  img.setAttribute("srcset", fullSrcset);
                  img.setAttribute("sizes", "(max-width: 749px) 100vw, 600px");
                }
              }
            }
          }
        }
        thumbs.forEach((t, i) => {
          t.classList.toggle("is-active", i === active);
          t.setAttribute("aria-selected", i === active ? "true" : "false");
        });
        if (counter) counter.textContent = `${active + 1} / ${count}`;
        updateThumbTrack(active);
        if (prev){ prev.disabled = active===0; prev.style.opacity = active===0 ? "0.35":""; prev.style.pointerEvents = active===0 ? "none":""; }
        if (next){ next.disabled = active===count-1; next.style.opacity = active===count-1 ? "0.35":""; next.style.pointerEvents = active===count-1 ? "none":""; }
      }
      thumbs.forEach((t, i) => t.addEventListener("click", () => update(i)));
      if (prev) prev.addEventListener("click", () => update(active - 1));
      if (next) next.addEventListener("click", () => update(active + 1));
      window.addEventListener("resize", function(){ updateThumbTrack(active); });
      root.addEventListener("pab:variantChange", (e) => {
        const idx =
          e.detail && typeof e.detail.galleryIndex !== "undefined"
            ? e.detail.galleryIndex
            : null;
        if (idx !== null) update(idx);
      });
      update(active);
    });
  }

  function initVariantPickers() {
    document.querySelectorAll("[data-pab-variant-picker]").forEach((picker) => {
      if (picker.dataset.pabInit) return;
      picker.dataset.pabInit = "1";

      const jsonEl = picker.querySelector("[data-pab-variants]");
      let variants = [];
      try {
        variants = JSON.parse(jsonEl.textContent.trim());
      } catch (_) {
        variants = [];
      }
      if (jsonEl) {
        jsonEl.hidden = true;
        jsonEl.style.display = "none";
      }

      const sizeGroup = picker.querySelector("[data-pab-size-group]");
      const offerGroup = picker.querySelector("[data-pab-offer-group]");
      const offerCards = offerGroup
        ? Array.from(offerGroup.querySelectorAll(".pab-offer-card"))
        : [];
      const gallery = document.querySelector("[data-pab-gallery]");
      const atcForm = document.querySelector("[data-pab-atc-form]");
      const atcBtn = document.querySelector("[data-pab-atc]");
      const priceSmall = parseInt(picker.dataset.pabSmallPrice || "3500", 10);
      const compareSmall = parseInt(
        picker.dataset.pabSmallCompare || "7000",
        10,
      );
      const priceLarge = parseInt(picker.dataset.pabLargePrice || "4500", 10);
      const compareLarge = parseInt(
        picker.dataset.pabLargeCompare || "9000",
        10,
      );

      function basePrice(sizeLow) {
        const s = (sizeLow || "").toLowerCase();
        return s.includes("large") ? priceLarge : priceSmall;
      }
      function baseCompare(sizeLow) {
        const s = (sizeLow || "").toLowerCase();
        return s.includes("large") ? compareLarge : compareSmall;
      }
      function findSingleVariantId(sizeLow) {
        const sl = (sizeLow || "").toLowerCase();
        const v = variants.find(
          (x) =>
            (x.option1 || "").toLowerCase() === sl &&
            (x.option2 || "").toLowerCase() === "single",
        );
        if (v) return v.id;
        const v2 = variants.find((x) => (x.option1 || "").toLowerCase() === sl);
        return v2 ? v2.id : variants[0] ? variants[0].id : null;
      }
      function computeBundle(offer, slots) {
        const o = (offer || "single").toLowerCase();
        function findVariantPrice(size, qty) {
          const sl = (size || "").toLowerCase();
          const ql = (qty || "").toLowerCase();
          const v = variants.find(
            (x) =>
              (x.option1 || "").toLowerCase() === sl &&
              (x.option2 || "").toLowerCase() === ql,
          );
          return v ? { price: v.price, compare: v.compare || 0 } : null;
        }
        if (o === "single") {
          const s = (slots[0] || "large").toLowerCase();
          const vp = findVariantPrice(s, "single");
          if (vp) return { price: vp.price, compare: vp.compare, slots: [s] };
          return { price: basePrice(s), compare: baseCompare(s), slots: [s] };
        }
        if (o === "duo") {
          const a = (slots[0] || "large").toLowerCase();
          const b = (slots[1] || "large").toLowerCase();
          if (a === b) {
            const vp = findVariantPrice(a, "duo");
            if (vp)
              return { price: vp.price, compare: vp.compare, slots: [a, b] };
          }
          const sum = basePrice(a) + basePrice(b);
          const sumC = baseCompare(a) + baseCompare(b);
          return { price: Math.round(sum * 0.9), compare: sumC, slots: [a, b] };
        }
        if (o === "trio") {
          const a = (slots[0] || "large").toLowerCase(),
            b = (slots[1] || "large").toLowerCase(),
            c = (slots[2] || "large").toLowerCase();
          if (a === b && b === c) {
            const vp = findVariantPrice(a, "trio");
            if (vp)
              return { price: vp.price, compare: vp.compare, slots: [a, b, c] };
          }
          const sum = basePrice(a) + basePrice(b) + basePrice(c);
          const sumC = baseCompare(a) + baseCompare(b) + baseCompare(c);
          return {
            price: Math.round(sum * 0.85),
            compare: sumC,
            slots: [a, b, c],
          };
        }
        return { price: priceLarge, compare: compareLarge, slots: ["large"] };
      }
      function formatMoney(cents) {
        if (window.Shopify && window.Shopify.formatMoney) {
          try {
            return window.Shopify.formatMoney(
              cents,
              window.Shopify.money_format || "${{amount}}",
            );
          } catch (_) {}
        }
        return "$" + (cents / 100).toFixed(2);
      }
      function getActiveSize() {
        if (!sizeGroup) return "large";
        const el = sizeGroup.querySelector(".is-active");
        return el
          ? (el.dataset.valueLow || el.dataset.value || "large").toLowerCase()
          : "large";
      }
      function getActiveOffer() {
        if (!offerGroup) return "single";
        const el = offerGroup.querySelector(".pab-offer-card.is-active");
        return el
          ? (el.dataset.pabOffer || el.dataset.offer || "single").toLowerCase()
          : "single";
      }
      function getSlotsForOffer(offer) {
        const card = offerGroup
          ? offerGroup.querySelector(".pab-offer-card--" + offer)
          : null;
        if (!card) return [getActiveSize()];
        const sels = Array.from(card.querySelectorAll("select[data-pab-slot]"));
        if (sels.length === 0) {
          // single has no selects — use active size
          return [getActiveSize()];
        }
        return sels.map((s) => (s.value || "large").toLowerCase());
      }
      function updateCardPrices() {
        offerCards.forEach((card) => {
          const offer = (
            card.dataset.pabOffer ||
            card.dataset.offer ||
            "single"
          ).toLowerCase();
          const slots = getSlotsForOffer(offer);
          const bundle = computeBundle(offer, slots);
          const priceEl = card.querySelector("[data-pab-card-price]");
          const compEl = card.querySelector("[data-pab-card-compare]");
          if (priceEl) priceEl.textContent = formatMoney(bundle.price);
          if (compEl) {
            if (bundle.compare && bundle.compare > bundle.price)
              compEl.textContent = formatMoney(bundle.compare);
            else compEl.textContent = "";
          }
        });
        // toast and hidden input sync for active offer
        const activeOffer = getActiveOffer();
        const activeSlots = getSlotsForOffer(activeOffer);
        const activeBundle = computeBundle(activeOffer, activeSlots);
        if (atcForm) {
          let toastSlots = activeSlots.join(" + ");
          atcForm.setAttribute(
            "data-pab-toast",
            "Added to cart — " +
              activeOffer.charAt(0).toUpperCase() +
              activeOffer.slice(1) +
              " (" +
              toastSlots +
              ") " +
              formatMoney(activeBundle.price),
          );
          atcForm.setAttribute("data-pab-bundle-offer", activeOffer);
          atcForm.setAttribute("data-pab-bundle-slots", activeSlots.join(","));
          atcForm.setAttribute(
            "data-pab-bundle-price",
            String(activeBundle.price),
          );
        }
        // sync primary variant input to first slot single variant (for fallback)
        const formInput = document.querySelector("[data-pab-variant-input]");
        if (formInput) {
          const firstSize = activeSlots[0] || getActiveSize();
          const vid = findSingleVariantId(firstSize);
          if (vid) formInput.value = vid;
        }
        // gallery sync
        if (gallery) {
          const isLarge = (activeSlots[0] || getActiveSize()).includes("large");
          const gIdx = isLarge ? 0 : 1;
          gallery.dispatchEvent(
            new CustomEvent("pab:variantChange", {
              detail: { galleryIndex: gIdx },
            }),
          );
        }
      }

      // Bind size pills
      if (sizeGroup) {
        sizeGroup.querySelectorAll(".pab-size-pill").forEach((btn) => {
          btn.addEventListener("click", () => {
            sizeGroup.querySelectorAll(".pab-size-pill").forEach((b) => {
              b.classList.remove("is-active");
              b.setAttribute("aria-checked", "false");
            });
            btn.classList.add("is-active");
            btn.setAttribute("aria-checked", "true");
            const chosen = (
              btn.dataset.valueLow ||
              btn.dataset.value ||
              "large"
            ).toLowerCase();
            // sync all slot selects to chosen size
            offerCards.forEach((card) => {
              card.querySelectorAll("select[data-pab-slot]").forEach((sel) => {
                sel.value = chosen;
              });
            });
            updateCardPrices();
          });
        });
      }
      // Bind offer cards (click anywhere but selects)
      offerCards.forEach((card) => {
        const offer = (
          card.dataset.pabOffer ||
          card.dataset.offer ||
          "single"
        ).toLowerCase();
        card.addEventListener("click", (e) => {
          if (e.target && e.target.closest && e.target.closest("select"))
            return;
          offerCards.forEach((c) => {
            c.classList.remove("is-active");
            c.setAttribute("aria-checked", "false");
          });
          card.classList.add("is-active");
          card.setAttribute("aria-checked", "true");
          updateCardPrices();
        });
        card.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            card.click();
          }
        });
        // bind selects inside this card
        card.querySelectorAll("select[data-pab-slot]").forEach((sel) => {
          sel.addEventListener("change", (ev) => {
            ev.stopPropagation();
            // ensure this card is active when its slot changes
            offerCards.forEach((c) => {
              c.classList.remove("is-active");
              c.setAttribute("aria-checked", "false");
            });
            card.classList.add("is-active");
            card.setAttribute("aria-checked", "true");
            updateCardPrices();
          });
          sel.addEventListener("click", (ev) => ev.stopPropagation());
        });
      });

      // Initial sync
      updateCardPrices();
    });

    // ATC form intercept — bundle multi-add
    const atcForms = document.querySelectorAll("[data-pab-atc-form]");
    atcForms.forEach((form) => {
      if (form.dataset.pabInit) return;
      form.dataset.pabInit = "1";
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const btn = form.querySelector("[data-pab-atc]");
        const origHTML = btn ? btn.innerHTML : "";
        if (btn) {
          btn.disabled = true;
          btn.textContent = "Adding…";
        }
        // Resolve bundle slots -> variant ids (single variants per slot)
        let offer = form.getAttribute("data-pab-bundle-offer") || "single";
        let slotsAttr = form.getAttribute("data-pab-bundle-slots") || "";
        let slots = slotsAttr
          ? slotsAttr
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          : [];
        if (slots.length === 0) {
          const picker = document.querySelector("[data-pab-variant-picker]");
          if (picker) {
            const sizePill = picker.querySelector(".pab-size-pill.is-active");
            const sz = sizePill
              ? (
                  sizePill.dataset.valueLow ||
                  sizePill.dataset.value ||
                  "large"
                ).toLowerCase()
              : "large";
            const offEl = picker.querySelector(".pab-offer-card.is-active");
            offer = offEl
              ? (
                  offEl.dataset.pabOffer ||
                  offEl.dataset.offer ||
                  "single"
                ).toLowerCase()
              : "single";
            if (offer === "single") slots = [sz];
            else if (offer === "duo") slots = [sz, sz];
            else if (offer === "trio") slots = [sz, sz, sz];
            else slots = [sz];
          } else slots = ["large"];
        }
        // map slots to variant ids via hidden JSON
        let variantIds = [];
        try {
          const picker = document.querySelector("[data-pab-variant-picker]");
          const jEl = picker
            ? picker.querySelector("[data-pab-variants]")
            : null;
          let vars = [];
          if (jEl) vars = JSON.parse(jEl.textContent.trim());
          slots.forEach((sz) => {
            const sl = (sz || "large").toLowerCase();
            let v = vars.find(
              (x) =>
                (x.option1 || "").toLowerCase() === sl &&
                (x.option2 || "").toLowerCase() === "single",
            );
            if (!v)
              v =
                vars.find((x) => (x.option1 || "").toLowerCase() === sl) ||
                vars[0];
            if (v && v.id) variantIds.push(v.id);
          });
        } catch (_) {}
        if (variantIds.length === 0) {
          const fdFallback = new FormData(form);
          if (!fdFallback.get("quantity")) fdFallback.set("quantity", "1");
          variantIds = [fdFallback.get("id")].filter(Boolean);
        }
        try {
          // sequential adds for bundle
          let lastRes = null;
          for (let idx = 0; idx < variantIds.length; idx++) {
            const vid = variantIds[idx];
            const fd = new FormData();
            fd.set("id", String(vid));
            fd.set("quantity", "1");
            // preserve selling_plan if present
            const sp = form.querySelector('[name="selling_plan"]');
            if (sp && sp.value) fd.set("selling_plan", sp.value);
            const res = await fetch(window.routes.cart_add_url + ".js", {
              method: "POST",
              headers: { Accept: "application/json" },
              body: fd,
            });
            lastRes = res;
            if (!res.ok) {
              const err = await res.json().catch(() => ({}));
              throw new Error(err.description || "Add to cart failed");
            }
          }
          if (!lastRes || !lastRes.ok) throw new Error("Add to cart failed");
          try {
            const sectionsRes = await fetch(window.routes.cart_url + ".js");
            if (sectionsRes.ok) {
              document.dispatchEvent(
                new CustomEvent("cart:refresh", { bubbles: true }),
              );
              const cartForm = document.querySelector("cart-drawer");
              if (cartForm && window.routes.cart_add_url) {
                const secRes = await fetch(
                  `${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`,
                );
                if (secRes.ok) {
                  const data = await secRes.json().catch(() => null);
                  if (data) {
                    if (data["cart-drawer"] && cartForm) {
                      const temp = document.createElement("div");
                      temp.innerHTML = data["cart-drawer"];
                      const newDrawer = temp.querySelector("cart-drawer");
                      if (newDrawer) cartForm.innerHTML = newDrawer.innerHTML;
                      if (cartForm.classList && cartForm.open) cartForm.open();
                      else if (cartForm.querySelector("details"))
                        cartForm.querySelector("details").open = true;
                      const drawerComp = document.querySelector("cart-drawer");
                      if (drawerComp && typeof drawerComp.open === "function")
                        drawerComp.open();
                    }
                    const bubble = document.querySelector("#cart-icon-bubble");
                    if (bubble && data["cart-icon-bubble"]) {
                      const tb = document.createElement("div");
                      tb.innerHTML = data["cart-icon-bubble"];
                      const nb = tb.querySelector("#cart-icon-bubble");
                      if (nb) bubble.innerHTML = nb.innerHTML;
                    }
                  }
                }
              }
            }
          } catch (_) {}
          showToast(form.dataset.pabToast || "Added to cart");
          const drawer = document.querySelector("cart-drawer");
          if (drawer && drawer.open) {
            try {
              drawer.open();
            } catch (_) {}
          }
        } catch (err) {
          const msg = err && err.message ? err.message : "Error";
          showToast(msg, true);
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = origHTML; // re-bind price after restore
            // need to re-run update to restore correct price text inside btn
            document
              .querySelectorAll("[data-pab-variant-picker]")
              .forEach((p) => {
                const ev = new Event("update");
                // trigger via manual call: find current variant and set btn text accordingly – simpler call updateUI again via dispatch
              });
          }
        }
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll("[data-pab-accordion]").forEach((root) => {
      if (root.dataset.pabInit) return;
      root.dataset.pabInit = "1";
      const btns = root.querySelectorAll("[data-accordion-btn]");
      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const expanded = btn.getAttribute("aria-expanded") === "true";
          const single = root.dataset.accordionSingle === "true";
          if (single && !expanded) {
            btns.forEach((b) => {
              if (b !== btn) {
                b.setAttribute("aria-expanded", "false");
                const p = document.getElementById(
                  b.getAttribute("aria-controls"),
                );
                if (p) p.hidden = true;
              }
            });
          }
          btn.setAttribute("aria-expanded", String(!expanded));
          const panel = document.getElementById(
            btn.getAttribute("aria-controls"),
          );
          if (panel) panel.hidden = expanded;
        });
      });
    });
  }

  function initFaqs() {
    document.querySelectorAll("[data-pab-faq]").forEach((root) => {
      if (root.dataset.pabInitFaq) return;
      root.dataset.pabInitFaq = "1";
    });
  }

  function initToasts() {}

  function showToast(text, isError) {
    const el = document.createElement("div");
    el.className = "pab-toast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    el.innerHTML =
      (isError
        ? ""
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 13l4 4L19 7"/></svg>') +
      "<span>" +
      text +
      "</span>";
    document.body.appendChild(el);
    setTimeout(() => {
      el.style.opacity = "0";
      el.style.transition = "opacity 0.3s";
      setTimeout(() => el.remove(), 300);
    }, 2600);
  }

  NS.initAll = initAll;
  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
